import React, { useState } from 'react';
import { ArrowLeft, Search } from 'lucide-react';
import { avatars, getAvatarCategories } from '../../data/avatars';
import { playSound } from '../../utils/soundManager';

const AvatarPicker = ({ selectedAvatar, onSelect, onBack }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const categories = getAvatarCategories();

  const filteredAvatars = avatars.filter(avatar => {
    const matchesCategory = selectedCategory === 'all' || avatar.category === selectedCategory;
    const matchesSearch = avatar.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleCategoryChange = (category) => {
    playSound('click');
    setSelectedCategory(category);
  };

  const handleAvatarClick = (avatar) => {
    playSound('click');
    onSelect(avatar);
  };

  return (
    <div className="avatar-picker-container">
      <div className="avatar-picker-content animate-fadeIn">
        <div className="avatar-picker-header">
          <button
            className="back-button hover-scale btn-press"
            onClick={onBack}
          >
            <ArrowLeft size={24} />
          </button>
          <h2>Choose Your Avatar</h2>
          <div className="avatar-count">
            {filteredAvatars.length} avatars
          </div>
        </div>

        <div className="avatar-picker-search">
          <div className="search-input-wrapper">
            <Search size={20} className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="Search avatars..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="avatar-categories">
          <button
            className={`category-chip hover-scale btn-press ${
              selectedCategory === 'all' ? 'active' : ''
            }`}
            onClick={() => handleCategoryChange('all')}
          >
            All ({avatars.length})
          </button>
          {categories.map((category) => (
            <button
              key={category.id}
              className={`category-chip hover-scale btn-press ${
                selectedCategory === category.id ? 'active' : ''
              }`}
              onClick={() => handleCategoryChange(category.id)}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </div>

        <div className="avatars-grid">
          {filteredAvatars.map((avatar, index) => (
            <div
              key={avatar.id}
              className={`avatar-option hover-scale animate-scaleIn ${
                selectedAvatar === avatar.emoji ? 'selected' : ''
              }`}
              onClick={() => handleAvatarClick(avatar)}
              style={{ animationDelay: `${index * 0.02}s` }}
              title={avatar.name}
            >
              <span className="avatar-option-emoji">{avatar.emoji}</span>
              {selectedAvatar === avatar.emoji && (
                <div className="avatar-selected-indicator">✓</div>
              )}
            </div>
          ))}
        </div>

        {filteredAvatars.length === 0 && (
          <div className="no-avatars-found">
            <p>😕 No avatars found</p>
            <p className="no-avatars-hint">Try a different search or category</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarPicker;
